export const LINKS = [
  {
    title: 'legal.label',
    links: [
      [
        { label: 'legal.faq', href: 'https://help.sweepking.com/en' },
        {
          label: 'legal.your-privacy-choice',
          onClick: () => window.Cookiebot.renew(),
        },
        { label: 'legal.privacy-policy', href: '/privacy-policy' },
        { label: 'legal.general-terms-of-use', href: '/general-terms-of-use' },
        { label: 'legal.cookies-policy', href: '/cookies-policy' },
      ],

      [
        { label: 'legal.payment-policy', href: '/payment-policy' },
        { label: 'legal.data-protection-policy', href: '/data-protection-policy' },
        { label: 'legal.cancellation-policy', href: '/cancellation-policy' },
        { label: 'legal.responsible-gaming-policy', href: '/responsible-gaming-policy' },
        { label: 'legal.return-refund-policy', href: '/return-refund-policy' },
      ],

      [
        { label: 'legal.affiliate-program', href: 'https://cannonball.partners/' },
        { label: 'legal.sweepstakes-rules', href: '/sweepstakes-rules' },
        { label: 'legal.promotional-terms', href: '/promotional-terms' },
      ],
    ],
  },
];
